<template>
  <generic-modal :modal-key="'failed_purchase'" :has-extra-modal-class="'store_popup_box purchase purchase_failed modal_cont'"
                 @close="$emit('close')">
    <template slot="content">
        <h1>{{ getTranslations.home_modals_failed_purchase_purchase_failed }}</h1>
        <img src="static/images/store/photo-fail.png" class="op_down_img">
        <p>{{ getTranslations.home_modals_failed_purchase_purchase_not_successful }}
          <br> {{ getTranslations.home_modals_failed_purchase_purchase_you_might }} <br>{{ getTranslations.home_modals_failed_purchase_purchase_why }}</p>
    </template>
  </generic-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import GenericModal from '../../sharedcomponents/GenericModal';

export default {
  name: 'failedPurchase',
  components: { GenericModal },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/store/FailedPurchase.vue